export default __webpack_public_path__ + "static/media/nft-3.4515e1b2.png";